import React from "react";
import CustomImageComponent from "../CustomImageComponent";

const OrderItem = React.memo(
  ({ item, onProductClick, onViewVariants, isPreOrder }) => {
    console.log("itemitemitemitemitemitemitemitem");
    console.log(item);
    const isProductType =
      item?.product_category_type_name?.toLowerCase() === "product";

    return (
      <div className="ordered-products">
        <div
          className="ordered-products-img"
          onClick={() => onProductClick(item)}
          style={{ cursor: "pointer" }}
        >
          <CustomImageComponent src={item?.product_image_url} />
        </div>

        <div className="ordered-products-info">
          <p className="para-highlight">{item?.product_name}</p>

          {isProductType ? (
            <>
              <p>
                Net Weight :{" "}
                {isPreOrder
                  ? item?.total_net_weight
                  : item?.product_avg_net_weight}{" "}
                gm
              </p>
              {/* <p>Wastage : {item?.product_wastage}</p> */}
              {item?.mode_name === "Wastage" && (
                <p>Wastage : {item?.product_wastage || "-"}</p>
              )}
              {item?.mode_name === "Fine" && (
                <p>Fine : {item?.total_product_per_pc_fine || "-"}</p>
              )}
              {item?.is_labour_enabled && (
                <p>
                  Labour
                  {item?.labour_type_code
                    ? ` (${item.labour_type_code})`
                    : ""}{" "}
                  : {item?.labour_rate_applied || "-"}
                </p>
              )}
              <p>Quantity : {item?.total_quantity}</p>

              {!isPreOrder && (
                <div className="variant-wrapper">
                  <div
                    className="view-variant-btn"
                    onClick={(e) => onViewVariants(e, item?.product_variants)}
                  >
                    View variants
                  </div>
                </div>
              )}
            </>
          ) : (
            <>
              <p>Quantity : {item?.total_quantity}</p>
              <p>Per Pc Rate : {item?.product_per_pc_rate}</p>
            </>
          )}
        </div>
      </div>
    );
  },
);

export default OrderItem;
